import slugify from "slugify";
const genId = (level, value) =>
  `${slugify(value.replace(".", "-").replace(/<[^>]*>?/gm, ""), {
    lower: true,
    strict: true,
  })}`;

export default genId;
